import { LandingNavbar } from "../components/Homepage/landing-navbar"
import PrivacyChoices from "../components/PrivacyChoices"

const PrivacyChoicesPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <PrivacyChoices />
        </div>
      </main>
    )
}

export default PrivacyChoicesPage